import { useQuery } from '@tanstack/react-query'
import { api, ApiHttpError } from '~/lib/api/client'
import type { MyStatsResponse } from '~/lib/api/types'

export const MY_STATS_QUERY_KEY = ['me', 'stats'] as const

export function useMyStats() {
  return useQuery<MyStatsResponse, ApiHttpError>({
    queryKey: MY_STATS_QUERY_KEY,
    queryFn: () => api.getMyStats(),
    refetchOnWindowFocus: true,
    staleTime: 60 * 1000,
  })
}
